const getModule = {
  state: {
    selected: false,
    url: '',
    type: '',
  },
  mutations: {
    setBuyukSehirImar1000(state, data) {
      if (state.type == data.type) {
        state.selected = false
        state.url = ''
        state.type = ''
      } else {
        state.selected = true
        state.url = data.url
        state.type = data.type
      }
    },
  },
  actions: {
    setBuyukSehirImar1000({ commit }, data) {
      commit('setBuyukSehirImar1000', data)
    },
  },
  getters: {},
}

export default getModule
